var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MChart',{attrs:{"series":_vm.metricSeries,"options":_vm.chartOptions,"height":"60px"}})}
var staticRenderFns = []

export { render, staticRenderFns }